import React from 'react';

export default function SunsetGradient({ children, style, theme, radius = 24 }) {
  return (
    <div style={{
      background: `linear-gradient(135deg, ${theme.sunsetA} 0%, ${theme.sunsetB} 55%, ${theme.sunsetC} 100%)`,
      borderRadius: radius, position: 'relative', overflow: 'hidden',
      border: `1.5px solid ${theme.elevatedBorder || theme.cardBorder}`,
      boxShadow: theme.shadow,
      ...style,
    }}>
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.4,
        background: 'radial-gradient(ellipse at 30% 100%, rgba(255,255,255,0.3), transparent 60%)',
        pointerEvents: 'none',
      }}/>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, rgba(45,27,78,0.42), rgba(45,27,78,0.24) 45%, rgba(45,27,78,0.30))',
        pointerEvents: 'none',
      }}/>
      <div style={{ position: 'relative', zIndex: 1, textShadow: '0 2px 14px rgba(45,27,78,0.42)' }}>
        {children}
      </div>
    </div>
  );
}
